import { QueryClient } from '@tanstack/react-query';
import { userQueries } from '@/queries/user/user.query';
import { settingsQueries } from '@/queries/communication/settings/settings.query';

export const profileLoader = (queryClient: QueryClient) => {
  return queryClient.fetchQuery(userQueries.profile());
};

export const userSettingsLoader = async (queryClient: QueryClient) => {
  try {
    return await queryClient.ensureQueryData(settingsQueries.settings());
  } catch (e) {
    return null;
  }
};
